import React, { useState } from 'react';

const styles = {
  heading: { fontSize: '1.3rem', fontWeight: '700', color: '#e0e0e0', marginBottom: '1.25rem' },
  section: {
    background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: '10px',
    padding: '1.25rem', marginBottom: '1.5rem',
  },
  sectionTitle: { fontSize: '1rem', fontWeight: '600', color: '#e0e0e0', marginBottom: '1rem' },
  label: { display: 'block', marginBottom: '0.4rem', color: '#999', fontSize: '0.85rem' },
  input: {
    width: '100%', maxWidth: '320px', padding: '0.6rem 0.85rem',
    background: '#0f0f23', border: '1px solid #2a2a4a', borderRadius: '7px',
    color: '#e0e0e0', fontSize: '0.95rem', outline: 'none', marginBottom: '1rem',
  },
  button: {
    padding: '0.6rem 1.2rem', background: '#4f46e5', border: 'none',
    borderRadius: '7px', color: '#fff', fontWeight: '600', cursor: 'pointer',
    fontSize: '0.9rem',
  },
  success: {
    background: 'rgba(34,197,94,0.15)', border: '1px solid rgba(34,197,94,0.4)',
    borderRadius: '8px', padding: '0.7rem 1rem', color: '#22c55e',
    marginBottom: '1rem', fontSize: '0.9rem',
  },
  error: {
    background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.4)',
    borderRadius: '8px', padding: '0.7rem 1rem', color: '#f87171',
    marginBottom: '1rem', fontSize: '0.9rem',
  },
};

export default function Settings() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  async function handleChangePassword(e) {
    e.preventDefault();
    setMessage(null);
    if (newPassword !== confirmPassword) {
      setMessage({ error: 'New password and confirmation do not match' });
      return;
    }
    if (newPassword.length < 8) {
      setMessage({ error: 'New password must be at least 8 characters' });
      return;
    }
    setLoading(true);
    try {
      const res = await fetch('/api/auth/change-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          currentPassword,
          newPassword,
        }),
      });
      const data = await res.json();
      if (res.ok && data.ok) {
        setMessage({ success: 'Password updated successfully.' });
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
      } else {
        setMessage({ error: data.error || 'Failed to update password' });
      }
    } catch {
      setMessage({ error: 'Network error. Please try again.' });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div style={styles.heading}>Settings</div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>Change password</div>
        <form onSubmit={handleChangePassword}>
          {message && message.success && <div style={styles.success}>{message.success}</div>}
          {message && message.error && <div style={styles.error}>{message.error}</div>}
          <label style={styles.label}>Current password</label>
          <input
            style={styles.input}
            type="password"
            value={currentPassword}
            onChange={e => setCurrentPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
          <label style={styles.label}>New password</label>
          <input
            style={styles.input}
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
          />
          <label style={styles.label}>Confirm new password</label>
          <input
            style={styles.input}
            type="password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
          />
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Updating...' : 'Update password'}
          </button>
        </form>
      </div>
    </>
  );
}
